/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_FORM',
  PUT: 'UPDATE_FORM',
  DELETE: 'DELETE_FORM',
  RESET: 'RESET_FORM',
  RELOAD: 'RELOAD_FORM',
  UPDATE_ITEM: 'UPDATE_LOCAL_FORM',
};

export const getDraftId = () => `form-${Date.now()}`;

export const formReducer = (state = {}, action) => {
  switch (action.type) {
    case types.POST:
      return { ...action.payload };
    case types.PUT:
      const newFormValues = { ...action.payload };
      const formEntries = Object.keys(newFormValues);
      formEntries.forEach((formEntry) => {
        if (Array.isArray(newFormValues[formEntry])) {
          newFormValues[formEntry] = [...newFormValues[formEntry]];
        }
      });
      return newFormValues;
    case types.DELETE:
      return {};
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return {};
    case types.UPDATE_ITEM:
      const { item, attribute } = action.payload;
      const newUpadateValues = { ...state };
      const newItem = { ...item, newItem: true };
      // this code only update the arrays
      // TODO we must develop for all the attributes
      if(Array.isArray(newUpadateValues[attribute])){
        const itemIndex = newUpadateValues[attribute].findIndex((x) => x.id === newItem.id);
        if (itemIndex >= 0) {
          const newData = [...newUpadateValues[attribute]];
          newData.splice(itemIndex, 1, newItem);
          newUpadateValues[attribute] = newData;
        } else {
          const newData = [...newUpadateValues[attribute]];
          newData.push(newItem);
          newUpadateValues[attribute] = newData;
        }
      }
      else{
        newUpadateValues[attribute] =item;
      }
      return newUpadateValues;
    default:
      return state;
  }
};
